// Hebrew translations
export const he = {
  brandName: "VAROTRADES Inc",
  login: "התחברות",
  register: "הרשמה",
  logout: "התנתקות",
  dashboard: "לוח בקרה",
  settings: "הגדרות",
  adminPanel: "פאנל מנהל",
  search: "חיפוש",
  viewAll: "הצג הכל",
  learnMore: "למידע נוסף",
  getStarted: "התחל עכשיו",
  downloadApp: "הורד אפליקציה",
  
  nav: {
    trade: "מסחר",
    markets: "שווקים",
    earn: "הרווח",
    learn: "למד",
    more: "עוד",
    spotTrading: "מסחר ספוט",
    spotTradingDesc: "קנה ומכור מעל 2,000 מטבעות קריפטו",
    futures: "חוזים עתידיים",
    futuresDesc: "סחר עם מינוף עד 125x",
    marginTrading: "מסחר במרווח",
    marginTradingDesc: "הגבר את כוח המסחר שלך",
    copyTrading: "העתקת מסחר",
    copyTradingDesc: "עקוב אחר סוחרים מובילים אוטומטית",
    tradingBots: "בוטים למסחר",
    tradingBotsDesc: "אטומציה של האסטרטגיות שלך 24/7",
    p2pTrading: "מסחר P2P",
    p2pTradingDesc: "סחר ישירות עם אחרים",
    marketOverview: "סקירת שוק",
    marketOverviewDesc: "כל השווקים והמחירים",
    cryptocurrencies: "מטבעות קריפטו",
    cryptocurrenciesDesc: "BTC, ETH ומעל 2000 עוד",
    newListings: "רישומים חדשים",
    newListingsDesc: "הוספות טוקנים אחרונות",
    topGainers: "מרוויחים מובילים",
    topGainersDesc: "הביצועים הטובים ביותר היום",
    simpleEarn: "Simple Earn",
    simpleEarnDesc: "חיסכון גמיש עד 12% APY",
    staking: "סטייקינג",
    stakingDesc: "נעל והרוויח פרסים",
    launchpool: "Launchpool",
    launchpoolDesc: "גדל טוקנים חדשים",
    hodlerAirdrops: "HODLer Airdrops",
    hodlerAirdropsDesc: "פרסים למחזיקים",
    cryptoAcademy: "אקדמיית קריפטו",
    cryptoAcademyDesc: "קורסים לכל הרמות",
    videoTutorials: "מדריכי וידאו",
    videoTutorialsDesc: "מדריכים צעד אחר צעד",
    articlesGuides: "מאמרים ומדריכים",
    articlesGuidesDesc: "ידע מעמיק",
    helpCenter: "מרכז עזרה",
    helpCenterDesc: "שאלות נפוצות ותמיכה",
    aboutUs: "אודותינו",
    aboutUsDesc: "הסיפור והמשימה שלנו",
    security: "אבטחה",
    securityDesc: "איך אנחנו מגנים עליך",
    proofOfReserves: "הוכחת רזרבות",
    proofOfReservesDesc: "100% שקיפות",
    careers: "קריירה",
    careersDesc: "הצטרף לצוות שלנו",
  },
  
  hero: {
    title1: "השער שלך לעולם",
    title2: "המטבעות הדיגיטליים",
    subtitle: "מהימן על ידי יותר מ-",
    traders: "49 מיליון",
    tradersText: "סוחרים",
    continueWith: "או המשך עם",
  },
  
  stats: {
    volume24h: "נפח מסחר 24 שעות",
    cryptocurrencies: "מטבעות קריפטו",
    simpleEarnApy: "תשואת Simple Earn",
    reserveRatio: "יחס רזרבות",
  },
  
  products: {
    title: "סחר בכל זמן ומקום",
    subtitle: "מוצרים מגוונים לכל אסטרטגיות המסחר",
    spotTrading: "מסחר ספוט",
    spotDesc: "מעל 2000 זוגות",
    futures: "חוזים עתידיים",
    futuresDesc: "עד 125x מינוף",
    copyTrading: "העתקת מסחר",
    copyDesc: "עקוב אחר מומחים",
    tradingBots: "בוטים למסחר",
    botsDesc: "אוטומטי 24/7",
    simpleEarn: "Simple Earn",
    earnDesc: "תשואות גמישות",
    launchpool: "Launchpool",
    launchDesc: "טוקנים חדשים",
    popular: "פופולרי",
    hot: "חם",
    easy: "קל",
    smart: "חכם",
    earn: "הרווח",
    exclusive: "בלעדי",
  },
  
  howToStart: {
    title: "איך להתחיל",
    step1Title: "צור חשבון",
    step1Desc: "הירשם וקבל פרסי קבלת פנים בלעדיים",
    step2Title: "רכישה מהירה",
    step2Desc: "קנה קריפטו בצעדים פשוטים",
    step3Title: "התחל לסחור",
    step3Desc: "סחר, העתק עסקאות והרווח עוד",
    welcomeBonus: "בונוס קבלת פנים",
    forNewUsers: "למשתמשים חדשים",
  },
  
  security: {
    title: "אנחנו מגנים על כל עסקה",
    subtitle: "אבטחה רב-שכבתית להגנה על הנכסים שלך",
    advancedSecurity: "אבטחה מתקדמת",
    advancedSecurityDesc: "חוזים חכמים מבוקרים וניטור על הרשת מונעים פגיעויות",
    proofOfReserves: "הוכחת רזרבות",
    proofOfReservesDesc: "הפלטפורמה הראשונה עם 100% רזרבות וביקורות שקופות",
    secureStorage: "אחסון מאובטח",
    secureStorageDesc: "אחסון אסטרטגי בארנקים קרים להגנה על הנכסים שלך",
  },
  
  cta: {
    title: "התחל את המסע שלך היום",
    subtitle: "הצטרף למיליוני סוחרים ברחבי העולם ותהנה מחוויית מסחר בטוחה ואמינה",
    createAccount: "צור חשבון חינם",
    exploreMarkets: "חקור שווקים",
  },
  
  footer: {
    products: "מוצרים",
    services: "שירותים",
    support: "תמיכה",
    company: "חברה",
    legal: "משפטי",
    description: "פלטפורמת מסחר גלובלית מהימנה למיליוני משתמשים. סחר בבטחה ושקיפות.",
    downloadApp: "הורד אפליקציה",
    sslEncrypted: "מוצפן SSL",
    reserves: "רזרבות",
    securityAudited: "ביקורת אבטחה",
    allRightsReserved: "כל הזכויות שמורות",
    riskWarning: "אזהרת סיכון: מסחר במטבעות קריפטו כרוך בסיכון גבוה. וודא שאתה מבין את הסיכונים לפני המסחר.",
    termsOfService: "תנאי שירות",
    privacyPolicy: "מדיניות פרטיות",
    riskDisclosure: "גילוי סיכונים",
    amlPolicy: "מדיניות AML",
    helpCenter: "מרכז עזרה",
    faq: "שאלות נפוצות",
    fees: "עמלות",
    apiDocs: "תיעוד API",
    submitRequest: "שלח בקשה",
    aboutVAROTRADES: "אודות VAROTRADES",
    news: "חדשות",
    partnerships: "שותפויות",
    buyCrypto: "קנה קריפטו",
  },
  
  promo: {
    signUpNow: "הירשם עכשיו וקבל עד",
    upTo: "",
    inRewards: "בפרסים",
  },
  
  priceCard: {
    hot: "חם",
    new: "חדש",
    gainers: "מרוויחים",
  },
  
  partners: {
    officialPartner: "שותף רשמי:",
  },
  
  loginPage: {
    title: "התחברות",
    welcome: "ברוך שובך ל-VAROTRADES",
    email: "אימייל",
    password: "סיסמה",
    forgotPassword: "שכחת סיסמה?",
    loggingIn: "מתחבר...",
    continueWith: "או המשך עם",
    noAccount: "אין לך חשבון?",
    registerNow: "הירשם עכשיו",
    demoAccount: "חשבון דמו:",
    invalidCredentials: "אימייל או סיסמה לא תקינים",
    twoFactorTitle: "אימות דו-שלבי",
    twoFactorDesc: "הזן את הקוד מאפליקציית האימות שלך",
    verify: "אמת",
    goBack: "חזור",
    invalidCode: "קוד אימות לא תקין",
  },
  
  registerPage: {
    title: "צור חשבון",
    subtitle: "הצטרף ל-VAROTRADES היום",
    welcomeBonus: "בונוס קבלת פנים $100",
    bonusDesc: "הירשם עכשיו וקבל את הבונוס שלך",
    firstName: "שם פרטי",
    lastName: "שם משפחה",
    confirmPassword: "אשר סיסמה",
    agreeToTerms: "אני מסכים ל",
    termsOfService: "תנאי השירות",
    and: "ו",
    privacyPolicy: "מדיניות הפרטיות",
    creatingAccount: "יוצר חשבון...",
    createAccount: "צור חשבון",
    registerWith: "או הירשם עם",
    haveAccount: "כבר יש לך חשבון?",
    mustAgree: "עליך להסכים לתנאי השירות",
    passwordMismatch: "הסיסמאות לא תואמות",
    passwordLength: "הסיסמה חייבת להכיל לפחות 6 תווים",
    accountFailed: "יצירת החשבון נכשלה",
  },
  
  marketsPage: {
    title: "שווקים",
    subtitle: "עקוב אחר מחירים, שווי שוק ונפחי מסחר",
    totalMarketCap: "שווי שוק כולל",
    volume24h: "נפח 24 שעות",
    btcDominance: "דומיננטיות BTC",
    activeCryptos: "קריפטו פעילים",
    all: "הכל",
    hot: "חם",
    newListings: "רישומים חדשים",
    topGainers: "מרוויחים מובילים",
    topLosers: "מפסידים מובילים",
    searchCoins: "חפש מטבעות...",
    filter: "סנן",
    name: "שם",
    price: "מחיר",
    change24h: "שינוי 24ש",
    volume: "נפח 24ש",
    action: "פעולה",
    trade: "סחר",
    loadMore: "טען עוד",
    readyToTrade: "מוכן להתחיל לסחור?",
    joinMillions: "הצטרף למיליוני סוחרים והתחל את מסע הקריפטו שלך היום",
  },
  
  learnPage: {
    title: "למד",
    titleHighlight: "מסחר",
    titleEnd: "קריפטו",
    subtitle: "קורסים, מדריכים ומאמרים חינמיים לשליטה במסחר מטבעות קריפטו",
    searchPlaceholder: "חפש קורסים, מאמרים, סרטונים...",
    all: "הכל",
    beginner: "מתחיל",
    trading: "מסחר",
    security: "אבטחה",
    defi: "DeFi",
    featuredCourses: "קורסים מומלצים",
    viewAll: "הצג הכל",
    videoTutorials: "מדריכי וידאו",
    articlesGuides: "מאמרים ומדריכים",
    faq: "שאלות נפוצות",
    faqSubtitle: "תשובות מהירות לשאלות נפוצות",
    viewAllFaqs: "הצג את כל השאלות הנפוצות",
    readyToPractice: "מוכן ליישם את מה שלמדת?",
    startTradingConfidence: "התחל לסחור בביטחון עם מה שלמדת",
    startTradingNow: "התחל לסחור עכשיו",
    lessons: "שיעורים",
    views: "צפיות",
    minRead: "דקות קריאה",
  },
  
  companyPage: {
    title: "אודות",
    titleHighlight: "VAROTRADES",
    subtitle: "בונים את עתיד הפיננסים על ידי הפיכת מטבעות קריפטו לנגישים, בטוחים ופשוטים לכולם.",
    registeredUsers: "משתמשים רשומים",
    countriesServed: "מדינות",
    dailyVolume: "נפח מסחר יומי",
    cryptocurrencies: "מטבעות קריפטו",
    ourStory: "הסיפור שלנו",
    ourStoryP1: "VAROTRADES נוסדה ב-2017 עם משימה פשוטה: להפוך מסחר במטבעות קריפטו לנגיש לכולם.",
    ourStoryP2: "מה שהתחיל כצוות קטן של חובבי קריפטו נלהבים הפך לפלטפורמה גלובלית המשרתת מיליוני משתמשים.",
    ourStoryP3: "היום, אנחנו גאים להיות אחת מבורסות הקריפטו המובילות בעולם.",
    ourValues: "הערכים שלנו",
    ourValuesSubtitle: "העקרונות שמנחים את כל מה שאנחנו עושים",
    securityFirst: "אבטחה קודם",
    securityFirstDesc: "אנחנו מעדיפים את בטיחות נכסי המשתמשים שלנו.",
    userCentric: "ממוקד משתמש",
    userCentricDesc: "כל החלטה מונחית על ידי מה שהטוב ביותר למשתמשים שלנו.",
    innovation: "חדשנות",
    innovationDesc: "אנחנו ממשיכים לדחוף גבולות לספק פתרונות מסחר מתקדמים.",
    globalAccess: "גישה גלובלית",
    globalAccessDesc: "להפוך מטבעות קריפטו לנגישים לכולם, בכל מקום.",
    securityTrust: "אבטחה ואמון",
    securityTrustSubtitle: "האבטחה שלך היא העדיפות העליונה שלנו",
    proofOfReserves: "הוכחת רזרבות",
    proofOfReservesDesc: "100% מנכסי המשתמשים מגובים וניתנים לאימות על הרשת בכל עת.",
    coldStorage: "אחסון קר",
    coldStorageDesc: "רוב הנכסים מאוחסנים בארנקים קרים מאובטחים ולא מקוונים.",
    regularAudits: "ביקורות סדירות",
    regularAuditsDesc: "ביקורות אבטחה של צד שלישי מבטיחות את הסטנדרטים הגבוהים ביותר.",
    insuranceFund: "קרן ביטוח",
    insuranceFundDesc: "קרן ייעודית להגנה על משתמשים מנסיבות בלתי צפויות.",
    leadershipTeam: "צוות ההנהגה",
    leadershipSubtitle: "הכירו את האנשים שמניעים את המשימה שלנו",
    globalPresence: "נוכחות גלובלית",
    globalPresenceSubtitle: "משרתים משתמשים ברחבי העולם עם תמיכה אזורית",
    joinOurTeam: "הצטרף לצוות שלנו",
    joinTeamDesc: "אנחנו תמיד מחפשים אנשים מוכשרים שחולקים את התשוקה שלנו לקריפטו.",
    viewOpenPositions: "הצג משרות פתוחות",
    teamMembers: "חברי צוות",
    countries: "מדינות",
    openRoles: "משרות פתוחות",
    remoteFriendly: "ידידותי לעבודה מרחוק",
    getInTouch: "צור קשר",
    getInTouchSubtitle: "יש לך שאלות? אנחנו כאן לעזור",
    emailUs: "שלח אימייל",
  },
  
  chat: {
    title: "עוזר VAROTRADES",
    online: "מחובר",
    welcomeMessage: "שלום! 👋 אני עוזר ה-AI של VAROTRADES.\n\nאיך אני יכול לעזור לך היום?",
    placeholder: "הקלד את ההודעה שלך...",
    poweredBy: "מופעל על ידי AI",
    instantSupport: "תמיכה מיידית 24/7",
    newChat: "צ'אט חדש",
    errorMessage: "מצטער, אירעה שגיאה. אנא נסה שוב.",
    connectionError: "מצטער, שגיאת חיבור. אנא נסה שוב מאוחר יותר.",
    quickQuestion1: "איך מתחילים לסחור?",
    quickQuestion2: "מהן העמלות?",
    quickQuestion3: "איך מפקידים?",
    quickQuestion4: "האם הפלטפורמה מאובטחת?",
  },
  
  languages: {
    ar: "العربية",
    en: "English",
    es: "Español",
    de: "Deutsch",
    zh: "中文",
    ja: "日本語",
    he: "עברית",
  },
};

export default he;
